import { useNavigate } from "react-router-dom"
import { ButtonVariant } from "components/button/types"
import { ModalAtomType } from "./atoms"
import Button from "components/button-v2"
import Modal from "components/modal-v2"

interface SaveDocumentModalProps {
	open: ModalAtomType
	setOpen: React.Dispatch<React.SetStateAction<ModalAtomType>>
	routeToNavigate: string
}

export interface NewLocalSaveDocumentModal {
	checkedAt: string
	save: boolean | null
	alreadShowDocuments: string[]
}

const SaveDocumentModal = ({
	open,
	setOpen,

	routeToNavigate,
}: SaveDocumentModalProps) => {
	const navigate = useNavigate()

	const onExit = () => {
		navigate(routeToNavigate)

		setOpen({
			open: false,
			isCancel: false,
		})
	}

	const onDiscard = async () => {
		setOpen({
			open: false,
			isCancel: false,
		})
	}

	return (
		<Modal
			isOpen={open.open}
			onClose={() =>
				setOpen({
					open: false,
					isCancel: open.isCancel,
				})
			}
			title="Você tem dados não salvos"
			maxWidth="max-w-[560px]"
		>
			<div className="flex  justify-center flex-col !font-Red-Hat-Display">
				<p className="text-[#6D6D6D] mb-6 text-cta-1">
					Se você sair agora, as informações preenchidas serão
					perdidas. Tem certeza de que deseja sair desta página?
				</p>

				<div className="flex items-center justify-between">
					<Button
						variant={ButtonVariant.Outlined}
						className="mr-4 w-[235px] justify-center"
						onClick={() => onDiscard()}
					>
						Cancelar
					</Button>
					<Button
						variant={ButtonVariant.Contained}
						className="flex w-[235px] justify-center"
						onClick={() => onExit()}
					>
						Sim
					</Button>
				</div>
			</div>
		</Modal>
	)
}

export default SaveDocumentModal
